//
// js-site-growl.js - growl behavior
//

import {get_cookie, set_cookie} from '../cookies/crumblr';
import cookie_acceptance from '../cookies/cookie-acceptance';
import str_hash from '../helpers/str-hash';

const els = {
  container: document.querySelector('.js-site-growl'),
  close_btn: document.querySelector('.js-site-growl__close'),
};

function create_cookie_name() {
  return `growl-${Math.abs(str_hash(els.container.textContent))}`;
}

function cookie_is_set(cookie_name) {
  const c = get_cookie(cookie_name);
  return c && c === 'Y';
}

function set_growl_cookie() {
  set_cookie(create_cookie_name(), 'Y', 182);
}


// Hide / show
// ------------------------------------

function hide() {
  els.container.classList.add('dn');
  set_growl_cookie();
  unbind_close_btn();
}

function show() {
  bind_close_btn();
  els.container.classList.remove('dn');
}

function bind_close_btn() {
  els.close_btn.addEventListener('click', hide);
}

function unbind_close_btn() {
  els.close_btn.removeEventListener('click', hide);
}


// init
// ------------------------------------

function init() {
  if (!cookie_acceptance.functional.is_accepted()) {
    return;
  }

  const cookie_name = create_cookie_name();

  if (!cookie_is_set(cookie_name)) {
    show();
  }
}

if (els.container) {
  init();
}

